/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, debounce, takeEvery, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { getConfigAppApi, getDetailHistoryFileCreateAPI, getInfoOrderAPI, getInfoOrderFileDetailAPI, getListHistoryFileCreateAPI, postCreateOrderApi, postCreateOrderFileApi, postCreateOrderFileEditApi, postCreateOrderNoLoginApi, postGetAllServiceAPI, postGetPriceOrderAPI, postUpdateInfoOrderApi, uploadFileCreateOrderAPI } from './helpers';
import { GET_ALL_SERVICE_ORDER_PRICE, GET_CONFIG_APP, GET_DETAIL_FILE_BY_ID, GET_INFO_ORDER, GET_INFO_ORDER_DETAIL_FILE, GET_LIST_FILE_BY_ID, GET_PRICE_ORDER, POST_CREATE_ORDER, POST_CREATE_ORDER_FILE, POST_CREATE_ORDER_FILE_EDIT, POST_CREATE_ORDER_NO_LOGIN, POST_UPDATE_INFO_ORDER, UPLOAD_FILE_CREATE_ORDER } from './constant';

function* takePostCreateOrderSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCreateOrderApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostUpdateInfoOrderSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postUpdateInfoOrderApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostCreateOrderNoLginSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCreateOrderNoLoginApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostGetAllServiceSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postGetAllServiceAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostGetPriceSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postGetPriceOrderAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetInfoOrderSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getInfoOrderAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

/// config

function* takeGetConfigAppSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getConfigAppApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

//excel----------------

function* takePostUploadFileCreateOrderSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(uploadFileCreateOrderAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetListHistoryFileCreateSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListHistoryFileCreateAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetDetailHistoryFileCreateSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getDetailHistoryFileCreateAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetInfoOrderFileDetaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getInfoOrderFileDetailAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostCreateOrderFileSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCreateOrderFileApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostCreateOrderFileEditSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCreateOrderFileEditApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

//---------------------------------

export default function* () {
  yield takeLatest(POST_CREATE_ORDER, takePostCreateOrderSaga);
  yield takeLatest(POST_UPDATE_INFO_ORDER, takePostUpdateInfoOrderSaga);
  yield takeLatest(POST_CREATE_ORDER_NO_LOGIN, takePostCreateOrderNoLginSaga);
  yield debounce(600, GET_ALL_SERVICE_ORDER_PRICE, takePostGetAllServiceSaga);
  yield debounce(600, GET_PRICE_ORDER, takePostGetPriceSaga);
  yield takeLatest(GET_INFO_ORDER, takeGetInfoOrderSaga);
  //////
  yield takeLatest(GET_CONFIG_APP, takeGetConfigAppSaga);
  //////
  yield takeLatest(UPLOAD_FILE_CREATE_ORDER, takePostUploadFileCreateOrderSaga);
  yield takeLatest(GET_LIST_FILE_BY_ID, takeGetListHistoryFileCreateSaga);
  yield takeLatest(GET_DETAIL_FILE_BY_ID, takeGetDetailHistoryFileCreateSaga);
  yield takeEvery(POST_CREATE_ORDER_FILE, takePostCreateOrderFileSaga);
  yield takeLatest(POST_CREATE_ORDER_FILE_EDIT, takePostCreateOrderFileEditSaga);
  yield takeLatest(GET_INFO_ORDER_DETAIL_FILE, takeGetInfoOrderFileDetaiSaga);
  //////
}

